<template>
  <TransitionGroup
    tag="div"
    name="transition-list"
    class="fixed right-5 left-5 sm:left-auto z-[500] space-y-1.5"
    :style="{ top: 'max(20px, var(--inset-top))'}"
    style="--duration: 200ms"
  >
    <ToasterItem
      v-for="toast in toastStore.items"
      v-bind="toast"
      :key="toast.id"
    />
  </TransitionGroup>
</template>

<script lang="ts" setup>
import ToastsStore from '@/store/toasts'

const toastStore = ToastsStore()


</script>